module.exports = __webpack_public_path__ + "media/images/pic/hero/sun-04e2357a25797b00370414187eed81b0.png";